import { Grid, Typography } from '@mui/material'
import { formatCurrency, stringToNumber } from 'utils'

export const ItemTotal = (props: any) => {
  const { formValues } = props
  const {
    currentPrice,
    defaultPrice,
    quantity: rawQuantity,
    discount,
    salePrice
  } = formValues
  const quantity = Number(stringToNumber(rawQuantity)) || 0
  const priceBase = currentPrice || defaultPrice

  // const icmsValue = priceValues?.icmsValue || 0
  // const ipiValue = priceValues?.ipiValue || 0
  // const stValue = priceValues?.stValue || 0

  return (
    <Grid container>
      <Grid container item justifyContent="flex-end" xs={8}>
        <Grid item>
          <Typography variant="caption">Sub Total</Typography>
        </Grid>
      </Grid>
      <Grid container item justifyContent="flex-end" xs={4}>
        <Grid item>
          <Typography style={{ fontSize: 14 }}>
            {formatCurrency((priceBase || 0) * quantity)}
          </Typography>
        </Grid>
      </Grid>

      {/* <Grid container item justifyContent="flex-end" xs={8}>
        <Grid item>
          <Typography variant="caption">ICMS</Typography>
        </Grid>
      </Grid>
      <Grid container item justifyContent="flex-end" xs={4}>
        <Grid item>
          <Typography style={{ fontSize: 14 }}>
            {formatCurrency(icmsValue)}
          </Typography>
        </Grid>
      </Grid> */}

      {/* <Grid container item justifyContent="flex-end" xs={8}>
        <Grid item>
          <Typography variant="caption">IPI</Typography>
        </Grid>
      </Grid>
      <Grid container item justifyContent="flex-end" xs={4}>
        <Grid item>
          <Typography style={{ fontSize: 14 }}>
            {formatCurrency(ipiValue)}
          </Typography>
        </Grid>
      </Grid> */}

      {/* <Grid container item justifyContent="flex-end" xs={8}>
        <Grid item>
          <Typography variant="caption">ST</Typography>
        </Grid>
      </Grid>
      <Grid container item justifyContent="flex-end" xs={4}>
        <Grid item>
          <Typography style={{ fontSize: 14 }}>
            {formatCurrency(stValue)}
          </Typography>
        </Grid>
      </Grid> */}

      <Grid container item justifyContent="flex-end" xs={8}>
        <Grid item>
          <Typography variant="caption">Desconto</Typography>
        </Grid>
      </Grid>
      <Grid container item justifyContent="flex-end" xs={4}>
        <Grid item>
          <Typography style={{ fontSize: 14 }}>
            {formatCurrency(discount * quantity)}
          </Typography>
        </Grid>
      </Grid>

      <Grid container item justifyContent="flex-end" xs={8}>
        <Grid item>
          <Typography style={{ fontSize: 14, fontWeight: 700 }}>
            Total
          </Typography>
        </Grid>
      </Grid>
      <Grid container item justifyContent="flex-end" xs={4}>
        <Grid item>
          <Typography style={{ fontSize: 14, fontWeight: 700 }}>
            {formatCurrency(salePrice * quantity)}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}
